import { cn } from '@/lib/ui/cn';
import { PropsWithChildren } from 'react';

type Props = PropsWithChildren & {
  className?: string;
};

export const BlogPagesShowOnMobile: React.FC<Props> = ({
  children,
  className,
}) => <div className={cn('lg:hidden', className)}>{children}</div>;
